
import axios, { AxiosResponse } from "axios";
import { Component, Vue } from "vue-property-decorator";
import GlobalConfig from "@/GlobalConfig";
import FundTypeObj from "@/models/WsdlResponses/FundTypeObj";
import WsdlService from "@/services/WsdlService";
import UmbracoApiService from "@/services/UmbracoApiService";
import Swal from "sweetalert2";
import NotificationAportesForm from "@/components/Notificacion_Aportes/NotificacionAportesForm.vue";
import NotificationAportesResult from "@/components/Notificacion_Aportes/NotificacionAportesResult.vue";
import NotificationAportesResponse from "@/components/Notificacion_Aportes/NotificacionAportesResponse.vue";
import AfiliadoService from "@/services/AfiliadoService";
import ServicioNotificacionBalanceModel from "@/models/ServicioNotificacionBalance/ServicioNotificacionBalanceModel";

@Component({
    components: {
        NotificationAportesForm,
        NotificationAportesResult,
        NotificationAportesResponse,
    },
})
export default class NotificationAportes extends Vue {
    public step: number = 1;
    public tipoFondo: FundTypeObj = new FundTypeObj();
    public userId: string = this.$store.state.user.cedula;
    public name: string = `${this.$store.state.user.primerNombre} ${this.$store.state.user.primerApellido}`;
    public wsdlService: WsdlService = new WsdlService();
    public umbracoService: UmbracoApiService = new UmbracoApiService();
    public isEmailActive: boolean = false;
    public isCelActive: boolean = false;
    public test: any[] = [];
	public umbracoBaseUrl: string = GlobalConfig.UMBRACO_BASE_URL;

    public labelData = new ServicioNotificacionBalanceModel();

    constructor() {
        super();
    }
	async getAllData() {
        this.labelData =
            await this.umbracoService.getServicioNotificacionAportes();
    }
    async getDropdownData() {
        this.wsdlService
            .getTipoDeFondos(this.userId, "")
            .then((response: AxiosResponse<FundTypeObj>) => {
                this.tipoFondo = response.data;
            });
    }
    public nextStep() {
        if (this.tipoFondo.tipofondos.emailusuario) {
            this.step++;
            return;
        }
        Swal.fire({
            text: "Debes tener tu e-mail registrado para recibir notificaciones por esta vía.",
            icon: "info",
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: "Actualizar Datos",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.value) {
                this.updateUser();
            }
        });
    }
    public updateNotificationData(
        isEmailActive: boolean,
        isCelActive: boolean
    ) {
        this.isEmailActive = isEmailActive;
        this.isCelActive = isCelActive;
    }
    returnHome() {
        window.location.href = GlobalConfig.BASE_URL
    }

    async mounted() {
		await this.getAllData();
        await this.getDropdownData();
    }
    updateUser() {
        this.$router.push("actualizacion-de-datos");
    }
}
